import React from "react";

export default function AdminPlaceholder({ label }) {
  return (
    <div className="card p-12 text-center">
      <p className="text-sm text-slate-400">
        <span className="font-medium text-slate-600">{label}</span> isn't wired up yet — let me
        know when you're ready to build this section out.
      </p>
    </div>
  );
}
